import { createAsyncThunk } from '@reduxjs/toolkit'
import ApprovalRequest from './approval-request-model'
import {
  delete_approvalRequest,
  load_approvalRequests,
  store_approvalRequest,
} from './approvalRequest-service'

export const LoadApprovalRequestsAsync = createAsyncThunk<any, any>(
  'composer/load/approvalRequest',
  async (params: { uid: string }) => {
    return await load_approvalRequests(params)
  },
)

export const CreateApprovalRequestAsync = createAsyncThunk<any, any>(
  'composer/create/approvalRequest',
  async (params: ApprovalRequest) => {
    return await store_approvalRequest(params)
  },
)

export const DeleteApprovalRequestAsync = createAsyncThunk<any, any>(
  'composer/delete/approvalRequest',
  async (params) => {
    return await delete_approvalRequest(params)
  },
)
